import { abyssColors } from '@/theme/colors';
import { styled as muiStyled } from '@mui/material/styles';
import { Stack } from '@mui/material';

export const Container = muiStyled(Stack)({
  height: '100%',
  width: '100%',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'relative',
  border: `0.2rem dashed ${abyssColors.primary[200]}`,
  borderRadius: '0.8rem',
  padding: '4.8rem',
  gap: '2.4rem',
  '& .MuiButton-icon': {
    marginLeft: 0,
  },
});
